import { queryOptions } from '@tanstack/react-query';

import { getIntegrationQueryKeys } from '@/entities/(integration)/integrations';
import { SOURCE_TYPE } from '@/types/feedbackConst';

import { getYotpoInfo } from './get-yotpo-info';

/**
 * Yotpo queryKeys 팩토리
 * getIntegrationQueryKeys를 래핑하여 기존 캐시 키와 호환 유지
 */
export const yotpoQueryKeys = {
  all: (workspaceAlias: string) =>
    getIntegrationQueryKeys(SOURCE_TYPE.YOTPO, workspaceAlias),
};

/**
 * Yotpo 연동 정보 목록 조회 queryOptions
 */
export const yotpoInfoQueryOptions = (
  workspaceAlias: string,
  options?: { enabled?: boolean },
) =>
  queryOptions({
    queryKey: yotpoQueryKeys.all(workspaceAlias),
    queryFn: () => getYotpoInfo({ workspace_id: workspaceAlias }),
    placeholderData: [],
    ...options,
  });
